<style scoped lang="scss" type="text/scss">
    /*必须写在最外层*/
    .search-box {
        width: 100%;
    }
</style>

<template>
    <el-select
            class="search-box"
            v-model="valueSync"
            filterable
            remote
            clearable
            :placeholder="placeholder"
            :remote-method="remoteMethod"
            :loading="loading">
        <el-option
                v-for="item in candidates"
                :key="item.id"
                :label="handleName(item.name)"
                :value="item.id">
            <span style="float: left">{{ handleName(item.name) }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px; margin-right: 1.5rem;">{{ item.role_cn_name }}</span>
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: '',
        props: {
            value: String | Number,
            placeholder: {
                type: String,
                default: '输入用户名（ 而非姓名 ）进行搜索（ 用户名不支持模糊搜索 ）'
            }
        },
        data () {
            return {
                defaultName: '@用户未输入姓名@',
                valueSync: null,
                loading: false,
                candidates: []
            };
        },
        watch: {
            value (value) {
                this.valueSync = value;
                if (value !== null && value !== undefined) {
                    this.$store.dispatch('user/loadUserInfo', {
                        id: value
                    }).then(response => {
                        this.candidates = [response.data];
                    });
                } else {
                    this.candidates = [];
                    this.valueSync = null;
                }
            },
            valueSync (valueSync) {
                if (valueSync === '') {
                    this.valueSync = null;
                    return;
                }
                this.$emit('input', valueSync);
            }
        },
        methods: {
            handleName (name) {
                return name === null ? this.defaultName : name;
            },
            remoteMethod (query) {
                if (query !== '') {
                    this.loading = true;
                    this.$normalRequest('user/searchByUsername', {username: query}).then(data => {
                        this.loading = false;
                        this.candidates = data;
                    }).catch(_ => {
                        this.loading = false;
                        this.candidates = [];
                    });
                } else {
                    this.candidates = [];
                }
            }
        }
    };
</script>
